import Grid from "@material-ui/core/Grid"
import Header from "layouts/dashbaord/Header"
import Container from "@material-ui/core/Container"

const Dashboard = ({ children }) => {
    return (
        <Grid>
            <Header />
            <Container>
                {children}
            </Container>
        </Grid>
    )
}

export default Dashboard
